import Navbar from "../components/Navbar";

export default function NoPage(){
  return(
    <div className="nopage">
      <Navbar />
      <div className="coming-soon">
        <h1>Coming Soon...</h1>
      </div>
    </div>
  )
}